import { render, staticRenderFns } from "./AcademySelect.vue?vue&type=template&id=0fa89573&scoped=true"
import script from "./AcademySelect.vue?vue&type=script&lang=js"
export * from "./AcademySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa89573",
  null
  
)

export default component.exports